var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFootLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.37822 12.4326C5.39039 12.4478 5.40561 12.463 5.41474 12.4783C5.98387 13.1661 6.46474 13.7078 6.72952 14C6.9943 13.7078 7.47517 13.1661 8.0443 12.4783C8.05343 12.463 8.06865 12.4478 8.08083 12.4326C9.71822 10.4391 12.0587 7.2587 12.0587 5.32913C12.0587 2.39217 9.66952 0 6.72952 0C3.78952 0 1.40039 2.39217 1.40039 5.32913C1.40039 7.2587 3.74083 10.4391 5.37822 12.4326ZM6.72952 2.7787C8.13561 2.7787 9.27996 3.92304 9.27996 5.32913C9.27996 6.73522 8.13561 7.87956 6.72952 7.87956C5.32343 7.87956 4.17909 6.73522 4.17909 5.32913C4.17909 3.92304 5.32343 2.7787 6.72952 2.7787Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFootLocation);
export default __webpack_public_path__ + "static/media/footLocation.e009e1ccbfc344d3e0e31dec11859d0b.svg";
export { ForwardRef as ReactComponent };